import { Box } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import DiscountPromo from "components/DiscountPromo/DiscountPromo"
import SingleButtonSelection from "components/Reusable/Bit/SingleButtonSelection"
import FormInput from "components/Reusable/FormsComp/FormInput"
import { useFormikContext } from "formik"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { usePurchaseContext } from "./PurchaseContext"
import HeadingText from "./Texts/HeadingText"

const StyledButton = styled(Box)<{
  $isSelected?: boolean
  $otherAmount?: boolean
}>`
  width: ${(p) => (p.$otherAmount ? "140px" : "110px")};
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 8px;
  border: 1px solid
    ${(p) => (p.$isSelected ? "var(--Yellow, #FFBC0D)" : "#e5e5e5")};
  background: var(--White, #fff);

  margin-top: 12px;
  margin-left: 10px;

  color: ${(p) => (p.$isSelected ? "#264f36" : "#757575")};

  font-size: 22px;
  font-family: "NarkisBlock-Thin", sans-serif;
  font-weight: ${(p) => (p.$isSelected ? "bold" : "normal")};

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: ${(p) => (p.$otherAmount ? "97px" : "71px")};
    height: 50px;
  }

  :hover {
    border: 2px solid var(--Grey, #757575);
  }
`

const StyledLabel = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
    > div {
      border: 1px solid ${(p) => p.theme.colors.darkGrey};
    }
  }
`
const StyledError = styled.p`
  margin: 0;
  padding: 0;
  text-align: right;
  color: #d70202;
  font-size: 18px;
  line-height: 1;
  ${(p) => p.theme.breakpoints.up("md")} {
    position: absolute;
    bottom: 0;
  }
`

const InputWrapper = styled(Box)<{ $focused: boolean }>`
  margin-top: 30px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 71px;
    .MuiFormHelperText-root {
      width: 150px;
    }
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 12px;
  }
  .MuiOutlinedInput-root {
    width: 71px;
    height: 50px;
    border-radius: 8px;
    border: 1px #e5e5e5 solid;
    background: var(--White, #fff);

    ${(p) => p.theme.breakpoints.up("md")} {
      height: 40px;
      width: 110px;
    }
  }
  fieldset {
    top: 0;
    height: 40px;
  }
  label {
    line-height: 1;
    transform: translate(-7px, 14px) scale(1);
    ${(p) => p.theme.breakpoints.up("md")} {
      transform: translate(-22px, 10px) scale(1);
    }

    color: #757575 !important;
  }
  input {
    color: #264f36;
    font-size: 22px;
    font-weight: bold;
    ${(p) => p.theme.breakpoints.down("sm")} {
      padding: 0px;
      text-align: center;
    }
    transform: translate(9px, 7px);
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(-8px, 4px) scale(0.75);
  }
`
const StyledBox = styled(Box)`
  position: relative;
  ${(p) => p.theme.breakpoints.up("md")} {
    div {
      :nth-child(2) {
        flex-wrap: nowrap;
      }
    }
    button {
      margin-left: 15px;
      width: 110px;
    }
  }
`
const StyledTextWrapper = styled(Box)`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    align-items: center;
    gap: 10px;
    h4 {
      font-size: 24px;
    }
  }
`

const StyledSingleButtonSelection = styled(SingleButtonSelection)`
  input:focus-visible + label div {
    outline: auto 2px Highlight;
    outline: auto 5px -webkit-focus-ring-color;
  }
`

const StyledButtonWrappers = styled(Box)`
  display: flex;
  flex-direction: column;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`

const GiftCardAmount = ({
  setAmountError,
  amountError,
  setQuantity,
  amounts,
  maxAmuont,
  minAmount,
  amountRef,
  noValueValidation,
  setNoValueValidation,
  validateForm,
  purchaseData,
  promotion,
}) => {
  const formikProps = useFormikContext<any>()
  const { setOtherAmount, otherAmount } = usePurchaseContext()
  const isDesktop = useIsDesktop()
  const [isDisabled, setIsDisabled] = useState(true)
  const [value, setValue] = useState("")

  useEffect(() => {
    if (noValueValidation) {
      setAmountError("יש לבחור סכום")
    } else {
      setAmountError("")
    }
  }, [noValueValidation])

  const checkAmountOnChange = (number) => {
    const quantity =
      formikProps.values.quantity === 0 ? 1 : formikProps.values.quantity
    if (quantity * number > maxAmuont) {
      setAmountError(`ניתן להכניס סכום מקסימלי של עד ${maxAmuont} ש״ח`)
    } else if (quantity * number < minAmount) {
      setAmountError(`ניתן להכניס סכום מינימלי של לפחות ${minAmount} ש״ח`)
    } else {
      setAmountError("")
    }
  }

  const handleButtonClick = (number: number | string) => {
    setTimeout(() => {
      validateForm()
    }, 500)
    setValue("")
    setNoValueValidation(false)
    setIsDisabled(true)
    if (number === -1) {
      setOtherAmount(true)
      setAmountError("")
    } else {
      setOtherAmount(false)
    }
    if (formikProps.values.quantity === 0) {
      formikProps.setFieldValue("quantity", 1)
      setQuantity(1)
    }
    if (number !== -1) {
      formikProps.setFieldValue("amount", number)
      checkAmountOnChange(number)
    } else formikProps.setFieldValue("amount", "")
  }

  const checkValidation = (e) => {
    const enteredValue = e.target.value.replace(/[₪]/g, "") // Remove the currency symbol (₪)
    if (
      enteredValue > maxAmuont ||
      formikProps.values.quantity * enteredValue > maxAmuont
    ) {
      setAmountError(`ניתן להכניס סכום מקסימלי של עד ${maxAmuont} ש״ח`)
    } else if (
      enteredValue < minAmount ||
      formikProps.values.quantity * enteredValue < minAmount
    ) {
      setAmountError(`ניתן להכניס סכום מינימלי של לפחות ${minAmount} ש״ח`)
    } else {
      setAmountError("")
    }
  }

  const isNumber = (evt) => {
    //only allow numbers
    const charCode = evt.which ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault()
    } else {
      if (formikProps.values.quantity === 0) {
        formikProps.setFieldValue("quantity", 1)
        setQuantity(1)
      }
    }
  }
  const formatCurrency = (value) => {
    const currencySymbol = "₪"
    if (value.length === 0) return ""
    if (value.toString().startsWith(currencySymbol)) {
      return value // Value already has the currency symbol, no need to modify
    }

    return `${currencySymbol}${value}` // Append the currency symbol (₪) to the value
  }

  useEffect(() => {
    getValue()
  }, [])

  const getValue = () => {
    const amount = purchaseData?.amount
    if (amount) {
      if (!amounts.includes(amount)) {
        setIsDisabled(false)
        setValue(formatCurrency(amount))
      } else {
        setValue("")
      }
    } else {
      setIsDisabled(true)
      setValue("")
    }
  }

  return (
    <StyledBox marginTop={"30px"}>
      <StyledTextWrapper>
        <HeadingText text="כמה בא לך לתת?" />{" "}
        {promotion && <DiscountPromo promoText={promotion} />}
      </StyledTextWrapper>
      <StyledButtonWrappers>
        <StyledSingleButtonSelection
          id="amount"
          items={amounts
            ?.filter((amount) => amount !== -1)
            .map((amount: number) => ({
              value: amount,
              name: `₪${amount}`,
            }))}
          onSelect={(code) => handleButtonClick(code)}
          gap={15}
          noFocus
          itemsPerRow={isDesktop ? 5 : "auto"}
          selectedValue={
            otherAmount
              ? -1
              : formikProps.values.amount > 0
              ? formikProps.values.amount
              : -2
          }
          customButton={(radioId, isSelected, item) => {
            const isOtherAmount = item.value === -1 || item.value === 5
            return (
              <>
                <StyledLabel htmlFor={radioId} $activeButton={isSelected}>
                  <StyledButton
                    $isSelected={isSelected}
                    $otherAmount={isOtherAmount}
                  >
                    <>{item.name}</>
                  </StyledButton>
                </StyledLabel>
              </>
            )
          }}
        />

        <InputWrapper $focused={!isDisabled}>
          <FormInput
            name="amount"
            label="סכום אחר"
            type="text"
            onBlurCapture={(e) => checkValidation(e)}
            onKeyUp={(e) => isNumber(e)}
            maxLength={5}
            numeric={true}
            id="input-amount"
            innerRef={amountRef}
            onFocusCapture={() => {
              formikProps.setFieldValue("amount", "")
            }}
            onClick={() => {
              setIsDisabled(false)
            }}
            value={
              isDisabled ? value : formatCurrency(formikProps.values.amount)
            }
            topMargin={"0"}
          />
        </InputWrapper>
      </StyledButtonWrappers>

      {amountError.length > 0 && (
        <StyledError aria-describedby="input-amount">{amountError}</StyledError>
      )}
    </StyledBox>
  )
}

export default GiftCardAmount
